import { DEFAULT_SSN } from '../constants/payment'

import { isSsn } from './validation'

export const parseSsn = (ssn, withoutDots = false) => {
  const parsedSsn = ssn?.replace(/[.-]/g, '')

  if (!ssn || !isSsn(parsedSsn)) return DEFAULT_SSN

  let ssnBody = ssn.slice(0, ssn.length - 2)
  if (withoutDots) {
    ssnBody = ssnBody.replace(/\./g, '')
  }

  const verifierDigit = ssn.charAt(ssn.length - 1).toUpperCase()

  return `${ssnBody}-${verifierDigit}`
}
